import React, { useState, forwardRef, useEffect } from "react";
import {
  Typography,
  Select,
  MenuItem,
  Box,
  Container,
  Tab,
  Tabs,
  AppBar,
  FormControl,
  InputLabel,
  Divider,
} from "@material-ui/core";
import * as firebase from "firebase";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import dayjs from "dayjs";
import ObjectsToCsv from "objects-to-csv";
import { CSVLink, CSVDownload } from "react-csv";
import _ from "lodash";
import MaterialTable from "material-table";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: theme.spacing(2),
  },
  root: {
    width: "100%",
    maxWidth: 360,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    position: "relative",
    overflow: "auto",
    maxHeight: 300,
  },
  container: {
    padding: theme.spacing(5),
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  select: {
    minWidth: "300px",
  },
  numbers: {
    display: "flex",
    flexDirection: "row",
  },
}));

export default function Dashboard() {
  let theme = useTheme();
  let db = firebase.firestore();
  const classes = useStyles();
  const [allCoupons, setAllCoupons] = React.useState();

  const [answers, setAnswers] = React.useState([]);
  const [buttonAnswers, setButtonAnswers] = React.useState();
  let notFound =
    buttonAnswers && answers ? buttonAnswers.tankstellen + answers.length : 0;
  const [answersExport, setanswersExport] = React.useState();
  const [value, setValue] = React.useState("open");
  const [finalAnswers2, setFinalAnswers] = React.useState([]);
  const [couponsExport, setcouponsExport] = React.useState([]);
  const [finalCoupons, setFinalCoupons] = React.useState([]);
  const [allAnswers, setAllAnswers] = useState();
  const [tableType, setTableType] = useState("coupons");
  const [data, setData] = useState();
  const [allVotes, setAllVotes] = useState();
  const [votesOriginal, setVotesOriginal] = useState();
  const claimedCoupons = _.filter(
    allCoupons,
    (coupon) => coupon.collected === true
  );

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTableChange = (event) => {
    setTableType(event.target.value);
  };

  const getData = () => {
    if (tableType === "coupons") {
      return allCoupons;
    } else if (tableType === "answers") {
      return allAnswers;
    } else if (tableType === "votes") {
      return allVotes;
    }
  };

  let columns = {
    coupons: [
      { title: "Coupon code", field: "code" },
      { title: "Used coupon", field: "collected" },
      { title: "Time of reservation", field: "claimedTime" },
      { title: "Time of expiration", field: "expiryTime" },
      { title: "Time of collection", field: "collectedTime" },
      { title: "Email", field: "email" },
      { title: "Fuel type", field: "fuel" },
      { title: "Reserved Fuel price", field: "price" },
      { title: "Collected Fuel price", field: "collectedPrice" },
      { title: "Collected liters", field: "collectedLiters" },
      { title: "Station Adress", field: "stationAdress" },
      { title: "Total discount", field: "discount" },
      { title: "Wie oft tankst du bei Total?", field: "howOften" },
    ],
    answers: [
      { title: "Answers", field: "answer" },
      { title: "Email", field: "email" },
      { title: "Submission time", field: "time" },
      { title: "Answer type", field: "type" },
    ],
    votes: [
      { title: "Submission time", field: "time" },
      { title: "Answer type", field: "type" },
    ],
  };
  const getColumns = () => {
    if (tableType === "coupons") {
      return columns.coupons;
    } else if (tableType === "answers") {
      return columns.answers;
    } else if (tableType === "votes") {
      return columns.votes;
    }
  };

  //  const createFile = ()=>{
  //   let finalAnswers =[]
  //    answersExport.map((answer)=>{
  //     finalAnswers.push({
  //       answer: answer?.answer?answer.answer:"",
  //       type: answer?.type?answer.type:"",
  //       email: answer?.email?answer.email:"",
  //       time:answer?.time?answer.time.toDate():"",
  //     })
  //     setFinalAnswers(finalAnswers)

  //   })}

  //   const createFile2 = ()=>{
  //     let finalCoupons =[]
  //      couponsExport.map((answer)=>{
  //       finalCoupons.push({
  //         code:answer?.code?answer.code:"",
  //         collected:answer?.collected?answer.collected:"",
  //         email:answer?.email?answer.email:"",
  //         expiryTime:answer?.expiryTime?answer.expiryTime:"",
  //         fuel:answer?.fuel?answer.fuel:"",
  //         fuelPrice:answer?.fuelPrice?answer.fuelPrice:"",
  //         fuelType:answer?.fuelType?answer.fuelType:"",
  //         price:answer?.price?answer.price:"",
  //         stationAdress:answer?.stationAdress?answer.stationAdress:"",
  //         claimedTime:answer?.claimedTime?answer.claimedTime.toDate():"",
  //         collectedTime:answer?.collectedTime?answer.collectedTime.toDate():"",
  //         discount:answer?.discount?answer.discount:"",
  //       })
  //       setFinalCoupons(finalCoupons)

  //     })}

  // React.useEffect(() => {
  //   db.collection("answers")
  //     .where("type", "==", value)
  //     .get()
  //     .then((snap) => {
  //       let answersArray = [];
  //       snap.forEach((doc) => {
  //         let data = doc.data();
  //         answersArray.push(data.answer);
  //       });
  //       setAnswers(answersArray);
  //     });
  // }, []);

//   useEffect(() => {
//     db.collection("answers")
//       .where("type", "==", "zeit")
//       .where("timeToSend", "<=", new Date())
//       .get()
//       .catch((error) => {
//         console.log("There was an error fetching data:", error);
//       })
//       .then((snap) => {
//         snap.docs.forEach((doc) => {
//           let data = doc.data();
//           console.log(data&&data.status!=='sent');
// console.log(data.email)
//             if(data&&data.status!=='sent'){
//               try {
//                 console.log('done')
//               } catch(error) {
//                 console.error('There was an error while sending the email:', error);
//               }
//             // doc.ref.update({status:'sent'})
//           }
//         });
//       });
//   }, []);

  React.useEffect(() => {
    db.collection("coupons")
      .get()
      .then((snap) => {
        let coupons = [];
        snap.docs.forEach((doc) => {
          let answer = doc.data();
          let coupon = {
            code: answer?.code ? answer.code : "",
            collected: answer.collected || false,
            email: answer?.email ? answer.email : "",
            expiryTime: answer?.expiryTime ? answer.expiryTime : "",
            fuel: answer?.fuel ? answer.fuel : "",
            fuelPrice: answer?.fuelPrice ? answer.fuelPrice : "",
            fuelType: answer?.fuelType ? answer.fuelType : "",
            price: answer?.price ? answer.price : "",
            stationAdress: answer?.stationAdress ? answer.stationAdress : "",
            claimedTime:
              dayjs(answer.claimedTime?.toDate()).format("YYYY/MM/DD HH:mm") ||
              "",
            collectedTime: answer.collectedTime
              ? dayjs(answer.collectedTime.toDate()).format("YYYY/MM/DD HH:mm")
              : "",
            discount: answer?.discount ? answer.discount : "",
            howOften: answer.howOften || "",
            collectedPrice: answer.collectedPrice || "",
            collectedLiters: answer.collectedLiters || "",
          };
          coupons.push(coupon);
        });

        setAllCoupons(coupons);
      });

    db.collection("answers")
      .get()
      .then((snap) => {
        let answers = [];
        snap.docs.forEach((doc) => {
          let answer = doc.data();
          let answerNew = {
            answer: answer.answer || "",
            email: answer.email || "",
            time: dayjs(answer.time?.toDate()).format("YYYY/MM/DD HH:mm") || "",
            type:
              answer.type === "preis"
                ? "Ich weiß nicht ob der Preis gerade günstig ist"
                : answer.type === "tankstelle"
                ? "Ich möchte bei einer anderen Tankstelle tanken"
                : answer.type === "zeit"
                ? "Ich habe aktuell noch einen vollen Tank"
                : answer.type === "zeitraum"
                ? "Reservierungszeitraum ist zu kurz"
                : "Anderer Grund/Sonstiges",
          };
          answers.push(answerNew);
        });

        setAllAnswers(answers);
      });

    db.collection("votes")
      .get()
      .then((snap) => {
        let answers = [];
        let votes = [];
        snap.docs.forEach((doc) => {
          let answer = doc.data();
          votes.push(answer);
          let answerNew = {
            time: dayjs(answer.time?.toDate()).format("YYYY/MM/DD HH:mm") || "",
            type:
              answer.type === "preis"
                ? "Ich weiß nicht ob der Preis gerade günstig ist"
                : answer.type === "tankstellen"
                ? "Ich möchte bei einer anderen Tankstelle tanken"
                : answer.type === "zeit"
                ? "Ich habe aktuell noch einen vollen Tank"
                : answer.type === "zeitraum"
                ? "Reservierungszeitraum ist zu kurz"
                : answer.type === "total"
                ? "Wie oft tankst du bei TOTAL?"
                : "Anderer Grund/Sonstiges",
            value: answer.value || "N/A",
          };
          answers.push(answerNew);
        });
        setVotesOriginal(votes);
        setAllVotes(answers);
      });
  }, []);

  return (
    <Container className={classes.container} maxWidth="false">
      <Box className={classes.numbers}>
        <Box className={classes.box}>
          <Typography variant="h5" color="textPrimary">
            Total No. of price reservations:
          </Typography>
          <Typography variant="h1" align="center" color="textPrimary">
            {allCoupons?.length}
          </Typography>
        </Box>
        <Box className={classes.box}>
          <Typography variant="h5" color="textPrimary">
            Total No. of coupons used:
          </Typography>
          <Typography variant="h1" align="center" color="textPrimary">
            {claimedCoupons?.length}
          </Typography>
        </Box>

        <Box className={classes.box}>
          <Typography variant="h5" color="textPrimary">
            Feedback summary:
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Ich weiß nicht ob der Preis gerade günstig ist:{" "}
            {_.filter(votesOriginal, (vote) => vote.type === "preis").length}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Ich möchte bei einer anderen Tankstelle tanken:{" "}
            {
              _.filter(votesOriginal, (vote) => vote.type === "tankstellen")
                .length
            }
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Ich habe aktuell noch einen vollen Tank:{" "}
            {_.filter(votesOriginal, (vote) => vote.type === "zeit").length}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Reservierungszeitraum ist zu kurz:{" "}
            {_.filter(votesOriginal, (vote) => vote.type === "zeitraum").length}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Anderer Grund/Sonstiges:{" "}
            {_.filter(votesOriginal, (vote) => vote.type === "other").length}
          </Typography>
        </Box>
        <Box className={classes.box}>
          <Typography variant="h5" color="textPrimary">
            Wie oft tankst du bei Total?
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Sonst nie:{" "}
            {_.filter(allCoupons, (vote) => vote.howOften == "nie").length}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Gelegentlich:{" "}
            {
              _.filter(allCoupons, (vote) => vote.howOften == "gelegentlich")
                .length
            }
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Haufig:{" "}
            {_.filter(allCoupons, (vote) => vote.howOften == "haufig").length}
          </Typography>
        </Box>
      </Box>
      <Divider
        style={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(4) }}
      />
      <FormControl
        className={classes.formControl}
        variant="outlined"
        color="secondary"
      >
        <InputLabel id="demo-simple-select-label">Data to show</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={tableType}
          onChange={handleTableChange}
          label="Data to show"
          className={classes.select}
        >
          <MenuItem value={"coupons"}>Coupons</MenuItem>
          <MenuItem value={"votes"}>Votes</MenuItem>
          <MenuItem value={"answers"}>Answers</MenuItem>
        </Select>
      </FormControl>

      <MaterialTable
        icons={tableIcons}
        columns={getColumns()}
        data={getData()}
        title="meinTankpreis data"
        options={{
          filtering: true,
          exportAllData: true,
          grouping: true,
          exportButton: true,
          exportFileName: "meinTankpreis Export",
        }}
      />
    </Container>
  );
}
